import React from 'react'
import { OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import moment from 'moment-timezone'

export default class Forcast extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <Table borderless striped>
        <thead>
          <tr className='text-center'>
            <th></th>
            <th>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Weather</Tooltip>}>
                <span title='Weather'>☁️</span>
              </OverlayTrigger>
            </th>
            <th className='d-none d-sm-table-cell'>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Maximum Temperature</Tooltip>}>
                <span>🌡️</span>
              </OverlayTrigger>
            </th>
            <th className='d-none d-sm-table-cell'>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Minimum Temperature</Tooltip>}>
                <span>🌡️</span>
              </OverlayTrigger>
            </th>
            <th className='d-table-cell d-sm-none'>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Average Temperature</Tooltip>}>
                <span>🌡️</span>
              </OverlayTrigger>
            </th>
            <th>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Gusts</Tooltip>}>
                <span>💨</span>
              </OverlayTrigger>
            </th>
            <th>
              <OverlayTrigger placement='bottom' overlay={<Tooltip>Wind Direction</Tooltip>}>
                <span>🧭</span>
              </OverlayTrigger>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.renderForcast(this.props.area)}
        </tbody>
      </Table>
    )
  }

  renderForcast () {
    return this.props.area.daily.time.map((date, i) => {
      date = moment(date, 'YYYY-MM-DD').format('ddd')
      return (
        <tr key={i} className='text-center' style={{ verticalAlign: 'middle' }}>
          <td className='text-end' style={{ fontWeight: 'bold' }}>{date}</td>
          <td>
            <OverlayTrigger placement='right' overlay={<Tooltip>{this.props.area.daily.weather_code[i].description}</Tooltip>}>
              <span>{this.props.area.daily.weather_code[i].emoji}</span>
            </OverlayTrigger>
          </td>
          <td className='d-none d-sm-table-cell'>{this.props.area.daily.temperature_2m_max[i]}{this.props.area.daily_units.temperature_2m_max}</td>
          <td className='d-none d-sm-table-cell'>{this.props.area.daily.temperature_2m_min[i]}{this.props.area.daily_units.temperature_2m_min}</td>
          <td className='d-table-cell d-sm-none'>{this.props.area.daily.temperature_2m_avg[i]}{this.props.area.daily_units.temperature_2m_max}</td>
          <td>{this.props.area.daily.wind_gusts_10m_max[i]} {this.props.area.daily_units.wind_gusts_10m_max}</td>
          <td>{this.props._transformDirection(this.props.area.daily.wind_direction_10m_dominant[i])} {this.props.area.daily.wind_direction_10m_dominant[i]}{this.props.area.daily_units.wind_direction_10m_dominant}</td>
        </tr>
      )
    })
  }
}
